import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksLinkfireAlternativeWhyChose: React.FC = () => {
  const intl = useIntl();

  return (
    <Container className="mt-5 pt-5">
      <p className="main-header text-center mb-3 mb-lg-5">
        {intl.formatMessage({
          id: 'sml.web.smart-links.linkfire_alternative.why_chose.title',
          defaultMessage: 'Why you should choose Music24'
        })}
      </p>
      <p className="main-header-subtitle text-center mb-3 mb-lg-5">
        {intl.formatMessage({
          id: 'sml.web.smart-links.linkfire_alternative.why_chose.subtitle',
          defaultMessage: 'Music24 is the best Linkfire alternative and music curation tool overall.'
        })}
      </p>
      <Row className="align-items-center">
        <Col xs={12} lg={6} className="order-lg-2 mt-5 text-center">
          <img
            src={nextAsset(`images/smartLinks/alternative/why-should-you-chose-smartlinks.png`, false, { w: 900 })}
            alt=""
            className="img-fluid"
          />
        </Col>
        <Col xs={12} lg={6} className="mt-5">
          <p className="fw-bold" style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.microsites.title',
              defaultMessage: 'It generates the most captivating microsites'
            })}
          </p>
          <p style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.microsites.description',
              defaultMessage:
                'You don’t want your followers to end up on a page with a bunch of links. Smart Links landing pages have a sleek music player with previews of your music content to hook your audience.'
            })}
          </p>
          <p className="fw-bold mt-5" style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.publishing.title',
              defaultMessage: 'Publishing playlists made easy!'
            })}
          </p>
          <p style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.publishing.description',
              defaultMessage:
                'Smart Links makes sharing music easier than ever, with less manual work. Once you’ve curated a playlist on the source platform, you can automatically feature it on various streaming services.'
            })}
          </p>
          <p className="fw-bold mt-5" style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.for_everyone.title',
              defaultMessage: "It's suitable both for independent music curators and big brands."
            })}
          </p>
          <p style={{ fontSize: '1.5rem' }}>
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.why_chose.for_everyone.description',
              defaultMessage:
                'We have plans for everyone. With features like advanced analytics and embed player, you can maximize your marketing efforts.'
            })}
          </p>
        </Col>
      </Row>
    </Container>
  );
};
